import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter", "counterText"]
  static values = { max: Number }

  connect() {
    this.update()
  }

  update() {
    if (!this.hasInputTarget || !this.hasCounterTextTarget) return

    const max = this.hasMaxValue ? this.maxValue : this.fallbackMax()
    const currentLength = this.inputTarget.value.length

    if (max > 0) {
      this.counterTextTarget.textContent = `${currentLength}/${max}`
    } else {
      this.counterTextTarget.textContent = `${currentLength}`
    }

    if (this.hasCounterTarget && max > 0) {
      const exceededClass = this.exceededClassName()
      if (exceededClass) {
        this.counterTarget.classList.toggle(exceededClass, currentLength > max)
      }
    }
  }

  fallbackMax() {
    const raw = this.inputTarget.getAttribute("maxlength")
    const parsed = Number.parseInt(raw, 10)
    return Number.isNaN(parsed) ? 0 : parsed
  }

  exceededClassName() {
    const baseClass = Array.from(this.counterTarget.classList).find((cls) =>
      cls.includes("form__character-counter")
    )

    return baseClass ? `${baseClass}--exceeded` : null
  }
}
